<template>
  <div id="debugMenu">



<!--    <button v-on:click="store.sendOrderToStrapi()" class="btn btn-secondary btn-sm">Send store Order</button>-->
    <button v-on:click="sendTestData" class="btn btn-secondary btn-sm">Send to swiss</button>

  </div>
</template>

<script>

import {store} from "./store.js";

export default {
  name: "DebugMenu",
  data() {
    return {
      store
    }
  },
  methods: {
    sendTestData(){
      var url = this.store.urls.jakeSwissUrl + "/api/order/create";
      const data = {"attributes":{"orderType":"seat","email":"xy@xy.cz","phone":"+ 420 468 232 123","sourceUrl":"http://localhost:3000/","sourceWeb":"localhost:3000","successCallbackURL":"http://localhost:3000/thankyou/trade-payment-success","errorCallbackURL":"http://localhost:3000/thankyou/trade-payment-error","currency":"CZK","items":[{"name":"Sídlo Praha 2, Varšavská 715/36 - 12 měsíců","code":"SP12","amount":"12","priceWithVat":"332.75","itemPriceWithoutVat":"275","vatRate":"1","amountUnit":"MTH","jakeIsId":"95"}],"paymentType":"BANK","addresses":[{"companyName":"xy","firstName":"xy","lastName":"xy","street":"xy","city":"xy","country":"CZ","postCode":"12345","ico":"12345678","dic":"dic","addressType":"invoice"}],"lang":"czech","totalPriceWithVat":"3993","totalPriceWithoutVat":"3300","orderNote":"<b>Souhrn:</b> <br><br> Produkty: <br>[SP12] <b>Sídlo Praha 2, Varšavská 715/36 - 12 měsíců</b> 3300 Kč bez DPH <br>","note":"xy","canSendIS":true}}
      this.axios.post(url, data).then((response) => {
        if (response.status === 201) {
          this.store.form.formSucceed = true;
          // odeslani lead do jake-swiss
          console.log(response.data)
          this.sendLeadOrder(response.data.uuid);

          if (this.store.order.paymentType === 'payment.bank') {
            this.finishOrder()
          } else if (this.store.order.paymentType === 'payment.card') {
            var orderGuid = response.data.uuid;
            console.log('Order UUID: ' + orderGuid);
            const gatewayUrl = this.store.urls.jakeSwissUrl + '/payment/gateway/' + orderGuid;
            try {
              window.top.location.href = gatewayUrl;
            } catch (e) {
              window.location.href = gatewayUrl;
            }
          }
        } else {
          console.log(response.data);
        }
      })
    },
    sendLeadOrder(orderId) {
      var o = this.store.order;
      // webhook
      var url = this.store.urls.jakeSwissUrl + '/raynet/send-lead-order/' + orderId;
      return this.axios.get(url).then((response) => {
        if (response.status === 200) {
          console.log('Odesláno do swiss/raynet')
          console.log(response.data)
          return true;
        } else {
          console.log(response)
          console.log(response.data);
          return false;
        }
      })
    },
  },
  computed: {},
  mounted() {
    console.log('DebugMenu Start')
  }
}
</script>

<style scoped>
#debugMenu {
  position: absolute;
  top: 0;
  left: 0;
  padding: .51rem;
  z-index: +1000;
  background-color: #dfc8ba;
}
</style>